import React from "react";
import { WorkstationSchemaEditor } from "../features/workstation-schemas";
import { withRestaurantId } from "../shared/components/layout";

const WorkstationSchemaEditorWithId = withRestaurantId(WorkstationSchemaEditor);

const WorkstationSchemaPage: React.FC = () => {
  return <WorkstationSchemaEditorWithId />;
};

export default WorkstationSchemaPage;
